/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateSqlEngineInput {
  /**
  * The name of the SQL engine
  */
  'name': string;
  /**
  * Number of worker nodes
  */
  'workerCount': number;
  /**
  * Worker node size profile
  */
  'workerSize': CreateSqlEngineInputWorkerSizeEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "workerCount",
      "baseName": "workerCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "workerSize",
      "baseName": "workerSize",
      "type": "CreateSqlEngineInputWorkerSizeEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateSqlEngineInput.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum CreateSqlEngineInputWorkerSizeEnum {
  Xs = 'xs',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Xl = 'xl'
}

